import Vue from 'vue'
import Router from 'vue-router'
import entrance from '@/components/entrance'                        //暂时入口
import typeBase from '@/view/type/base'                             //tab 分类
import indexBase from '@/view/index/base'                           //tab 首页
import shopCarBase from '@/view/shopCar/base'                       //tab 购物车
import personBase from '@/view/person/base'                         //tab 个人中心

//个人中心模块
import myorders from '@/view/person/myorders'                       //我的订单
import userSettingPage from '@/view/person/userSettingPage'         //用书设置
import updatePassword from '@/view/person/updatePassword';          //更新密码
import updatePhone from '@/view/person/updatePhone';                //修改电话
import addressManagement from '@/view/person/addressManagement';    //地址管理
import addressEdit from '@/view/person/addressEdit';                //地址编辑
import mycoupon from '@/view/person/mycoupon';                      //我的优惠券
import aboutus from '@/view/person/aboutus';                        //关于我们
import feedback from '@/view/person/feedback';                      //意见反馈

import typelist from '@/view/type/typeList';                        //二级分类列表
import typeDetail from '@/view/type/detail';                        //商品详情
import searchPage from '@/view/type/searchPage';                    //评论

import brandDetail from '@/view/index/brandDealer';                  //品牌商详情
import brandList from '@/view/index/brandList';                      //品牌商列表
import couponList from '@/view/index/couponList';                    //优惠券列表
import newProductStart from '@/view/index/newProductStart';          //新品首发列表
import recommend from '@/view/index/recommend';                      //人气推荐列表
import featureSelection from '@/view/index/featureSelection';        //专题精选列表

import featureDetail from '@/view/index/featureDetail';              //题精选详情

import commentPage from '@/view/index/commentPage';                  //评论


import favourate from '@/view/person/favourate';                    //我的收藏
import sigin from '@/view/pages/sigin';                             //注册
import register from '@/view/pages/register';                       //注册
import agreement from '@/view/pages/agreement';                     //用户协议
import myorderdetail from '@/view/person/myorderdetail';            //用户协议
import orderPage from '@/view/type/orderPage';                      //填写订单
import paymentResult from '@/view/type/paymentResult';              //支付结果
import selectCoupon from '@/view/shopCar/selectCoupon';              //我的优惠券
import evaluate from '@/view/person/evaluate';                      //评价页面
import payment from '@/view/type/payment';                          //
import newPayment from '@/view/type/newPayment';                          //新支付方式



import selectAddress from '@/view/person/selectAddress';              //地址选择
import logistics from '@/view/person/logistics';                    //查看物流信息
import forgetPwd from '@/view/pages/forgetPwd';                    //忘记密码

import allComment from '@/view/type/allComment';                    //商品全部评论

import myComments from '@/view/person/myComments';                    //我的评论
import indexDetail from '@/view/index/typeDetail';                    // 









Vue.use(Router);
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
};
export default new Router({ //type:1  为一级页面    type：2 为二级页面
  routes: [

    {
      path: "/login",
      name: "登录",
      component: sigin,
      props: true,
      meta: {
        index: 51,
      },
    },
    {
      path: "/register",
      name: "注册",
      component: register,
      meta: {
        index: 52,
      },
    },
    {
      path: "/forgetPwd",
      name: "忘记密码",
      component: forgetPwd,
      meta: {
        index: 53,
      },
    },

    {
      path: "/agreement",
      name: "用户协议",
      component: agreement,
      meta: {
        index: 54,
      },
    },


    {
      path: '/',
      component: entrance,
      redirect: "index",
      children: [
        {
          path: '/index',
          name: '首页',
          component: indexBase,
          meta: {
            scrollTop: 0,
            index: 0,
            type: 1
          }
        },
        {
          path: '/type',
          name: '分类',
          component: typeBase,
          meta: {
            type: 1,
            index: 1
          },
          children: [
            {
              path: 'detail',
              name: '商品详情',
              component: typeDetail,
              meta: {
                index: 23

              },

            },
            {
              path: 'payment',
              name: '支付方式',
              component: payment,
              meta: {
                index: 43

              },
            },
            {
              path: 'newPayment',
              name: '支付',
              component: newPayment,
              meta: {
                index: 43

              },
            },
            {
              path: 'result',
              name: '支付结果',
              component: paymentResult,
              meta: {
                index: 44

              },
            },
          ]
        },
        {
          path: '/shopCar',
          name: '购物车',
          component: shopCarBase,
          meta: {
            type: 1,
            index: 2
          },
        },
        {
          path: '/person',
          name: '个人中心',
          component: personBase,
          meta: {
            index: 3
          },
        },
        {
          path: '/detail',
          name: '分类列表',
          component: indexDetail,
          meta: {
            index: 11
          }
        },
        {
          path: 'brandDetail',
          name: '品牌商详情',
          component: brandDetail,
          meta: {
            index: 12
          },
        },
        {
          path: 'brandList',
          name: '品牌商列表',
          component: brandList,
          meta: {
            index: 13
          },
        },
        {
          path: 'couponList',
          name: '优惠券列表',
          component: couponList,
          meta: {
            index: 14
          },
        },
        {
          path: 'newProductStart',
          name: '新品首发',
          component: newProductStart,
          meta: {
            index: 15
          },
        },
        {
          path: 'recommend',
          name: '人气推荐',
          component: recommend,
          meta: {
            index: 16
          },
        },
        {
          path: 'featureSelection',
          name: '专题精选',
          component: featureSelection,
          meta: {
            index: 17
          },
        },
        {
          path: 'featureDetail',
          name: '专题详情',
          component: featureDetail,
          meta: {
            index: 18
          },
        },
        {
          path: 'commentPage',
          name: '评论',
          component: commentPage,
          meta: {
            index: 19
          },
        },
        {
          path: 'typelist',
          name: '分类列表',
          component: typelist,
          meta: {
            index: 20
          },
        },
        {
          path: 'searchPage',
          name: '搜索',
          component: searchPage,
          meta: {
            index: 21
          },
        },
        {
          path: 'order',
          name: '填写订单',
          component: orderPage,
          meta: {
            index: 24
          },
        }, {
          path: 'allComment',
          name: '商品评论',
          component: allComment,
          meta: {
            index: 42
          },
        },
        {
          path: 'selectCoupon',
          name: '我的优惠券',
          component: selectCoupon,
          meta: {
            index: 25
          },
        },
        {
          path: 'evaluate',
          name: '评价',
          component: evaluate,
          meta: {
            index: 32
          },
        },
        {
          path: 'aboutus',
          name: '关于我们',
          component: aboutus,
          meta: {
            index: 27
          },
        }, {
          path: 'feedback',
          name: '意见反馈',
          component: feedback,
          meta: {
            index: 28
          },
        },
        {
          path: 'mycoupon',
          name: '我的优惠券',
          component: mycoupon,
          meta: {
            index: 29
          },
        }, {
          path: 'phonebind',
          name: '绑定手机',
          component: updatePhone,
          meta: {
            index: 30
          },
        },
        {
          path: 'myorders/:activeTag',
          name: '我的订单',
          component: myorders,
          meta: {
            index: 21,
            scrollTop: 0,
          },
        }, {
          path: 'myorderdetail',
          name: '订单详情',
          component: myorderdetail,
          meta: {
            index: 26
          },
        }, {
          path: 'logistics',
          name: '物流信息',
          component: logistics,
          meta: {
            index: 33
          },
        }, {
          path: 'myComments',
          name: '我的评论',
          component: myComments,
          meta: {
            index: 30
          },
        },

        {
          path: 'userSetting',
          name: '用户设置',
          component: userSettingPage,
          meta: {
            index: 35
          },
        },
        {
          path: 'updatePassword',
          name: '修改密码',
          component: updatePassword,
          meta: {
            index: 36
          },
        }, {
          path: 'updatePhone',
          name: '修改手机号',
          component: updatePhone,
          meta: {
            index: 37
          },
        }, {
          path: 'addressManagement',
          name: '地址管理',
          component: addressManagement,
          meta: {
            index: 38
          }
        }, {
          path: 'selectAddress',
          name: '选择地址',
          component: selectAddress,
          meta: {
            index: 39
          }
        },
        {
          path: 'addressNew',
          name: '新增地址',
          component: addressEdit,
          meta: {
            index: 40
          },
        }, {
          path: 'favourate',
          name: '我的收藏',
          component: favourate,
          meta: {
            index: 41
          },
        },

      ]
    },

  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js